import React from 'react'
import styled from '@emotion/styled'
import { object } from 'prop-types'
import { useTheme } from 'emotion-theming'

import { ClipBoard, Considered, Ribbon } from '@jelly/components'

const OurApproachWrapper = styled.div`
	display: flex;
	${({ theme }) => theme.bestPicks.ourApproachBackground};
	flex-direction: column;
	padding: 34px;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		flex-direction: row;
		margin-top: 32px;
		padding: 40px 50px;
	}
`
const ContextContainer = styled.div`
	margin: auto;
	padding-bottom: 40px;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		border-bottom: 0;
		padding-bottom: 0;
		width: calc(40% + 30px);
	}
`
const Header = styled.div`
	color: ${({ theme }) => theme.colors.white};
	font-size: 2rem;
	margin-bottom: 16px;
	text-align: center;
	text-transform: uppercase;

	${({ theme }) => theme.MQ.M} {
		padding-right: 2rem;
		text-align: left;
	}

	${({ theme }) => theme.MQ.L} {
		font-family: 2.25rem;
	}
`
const DescriptionText = styled.div`
	display: flex;
	color: ${({ theme }) => theme.colors.white};
	text-align: center;

	${({ theme }) => theme.MQ.M} {
		padding-right: 2rem;
		text-align: left;
	}
`
const Divider = styled.div`
	border-bottom: 1px solid rgb(255, 255, 255, 0.5);
	height: 1px;
	margin: auto;
	width: 90%;

	${({ theme }) => theme.MQ.M} {
		border-right: 1px solid rgb(255, 255, 255, 0.5);
		height: 112px;
		width: 1px;
	}

	/* ${({ theme }) => theme.MQ.L} {
		bottom: 0;
		margin: auto 0 0 0;
	} */
`
const StatsContainer = styled.div`
	${({ theme }) => theme.fonts.bold};
	align-items: center;
	bottom: 0;
	display: flex;
	color: ${({ theme }) => theme.colors.white};
	flex-direction: column;
	flex-wrap: wrap;
	height: 100%;
	margin: 20px auto;
	width: 250px;
	text-align: center;

	${({ theme }) => theme.MQ.S} {
		flex-direction: row;
		justify-content: space-between;
		width: 80%;
		max-width: 450px;
	}

	${({ theme }) => theme.MQ.M} {
		height: auto;
		padding-left: 2rem;
		width: 60%;
	}

	${({ theme }) => theme.MQ.XL} {
		padding: 0;
	}
`
const Statistic = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 18px;
	margin: 0.5rem auto;

	${({ theme }) => theme.MQ.S} {
		margin: auto;
		margin-right: 16px;
		:last-child {
			margin: auto;
		}
	}
`
const Top = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
`
const Number = styled.div`
	font-size: 56px;
	margin-left: 10px;
`

OurApproach.propTypes = {
	ourapproach: object,
}

/**
 * This is the Our Approach section, hard coded statistics and a link
 * @param {object} ourapproach :: ourapproach object that includes servicesConsidered, servicesTested, and servicesSelected
 */
export function OurApproach({ ourapproach }) {
	const { servicesConsidered, servicesTested, servicesSelected } = ourapproach
	const hasNoServiceData = servicesConsidered === '0' && servicesTested === '0' && servicesSelected === '0'
	const {
		bestPicks: { primarySvgColor, secondarySvgColor },
	} = useTheme()
	return (
		!hasNoServiceData && (
			<OurApproachWrapper>
				<ContextContainer>
					<Header>How We Decided</Header>
					<DescriptionText>
						Our team spends weeks evaluating dozens of business solutions to identify the best options. To
						stay current, our research is regularly updated.
					</DescriptionText>
				</ContextContainer>
				<Divider />
				<StatsContainer>
					<Statistic>
						<Top>
							<Considered primaryColor={primarySvgColor} secondaryColor={secondarySvgColor} />
							<Number>{servicesConsidered}</Number>
						</Top>
						Considered
					</Statistic>
					<Statistic>
						<Top>
							<ClipBoard primaryColor={primarySvgColor} secondaryColor={secondarySvgColor} />
							<Number>{servicesTested}</Number>
						</Top>
						Researched
					</Statistic>
					<Statistic>
						<Top>
							<Ribbon primaryColor={primarySvgColor} secondaryColor={secondarySvgColor} />
							<Number>{servicesSelected}</Number>
						</Top>
						Selected
					</Statistic>
				</StatsContainer>
			</OurApproachWrapper>
		)
	)
}
